let buyNow = document.getElementById("buy_now");


buyNow.addEventListener("click", (e) => {
  let addToCartForm = e.target.closest('form[action*="/cart/add"]');
  let formData = new FormData(addToCartForm);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      console.log("Status Code:", response.status);

      if (response.ok) {
        window.location.href = "/checkout";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

const input = document.querySelector('.shopify-section--main-product .quantity-selector__input');
 input?.addEventListener('input', (e)=> { 
  const max = Number(e.target.max) 
  const value = Number(e.target.value); 
  if (value > 100) { e.target.value = max; } 
})

document.querySelectorAll('.shopify_subscriptions_fieldset input')
  .forEach(input => {
    input?.addEventListener('change', function(event) {     
      const element = event.target;
      const price = element.dataset.variantPrice;
      const cleanedPriceValue = price.replace(/\s*USD\s*/i, '');
      document.querySelector('product-sticky-add-to-cart sale-price').innerHTML = cleanedPriceValue;
    });
  });
